import { render } from "./PhoneComponent.vue?vue&type=template&id=3a65ce8f&scoped=true"
import script from "./PhoneComponent.vue?vue&type=script&lang=js"
export * from "./PhoneComponent.vue?vue&type=script&lang=js"

import "./PhoneComponent.vue?vue&type=style&index=0&id=3a65ce8f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a65ce8f"]])

export default __exports__